import { RDUsdaUnderservedSmall } from '@cibo/core'
import { ResourceDetailFeature } from '@cibo/ui'
import { RDUsdaUnderservedSmallTaskEditor } from './RDUsdaUnderservedSmallTaskEditor'

export const RDUsdaUnderservedSmallResourceDetailFeature: ResourceDetailFeature<RDUsdaUnderservedSmall> =
  {
    traitId: 'usdaUnderservedSmall',
    TaskEditor: RDUsdaUnderservedSmallTaskEditor,
  }
